import Ribbon from '../dataset/chord/ribbon';

/**
 * function to instatiate ribbon and get attached to manager
 * @param {Object} manager manager API
 */
export default function (manager) {
  let links = manager.config.links;
  for (let key in links) {
    if (links.hasOwnProperty(key)) {
      if (links[key].visible) {
        manager.attachChild(Ribbon, 'ribbon', key).configure(links[key]);
      }
    }
  }
}
